import { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { PlayerProvider } from './contexts/PlayerContext';
import { AdminProvider } from './contexts/AdminContext';
import SurahListPage from './pages/SurahListPage';
import SurahDetailPage from './pages/SurahDetailPage';
import MutashabihatPage from './pages/MutashabihatPage';
import api from './lib/api';
import './App.css';

function AppContent() {
  const [selectedSurah, setSelectedSurah] = useState(null);
  const [sharedExcerptId, setSharedExcerptId] = useState(null);
  const [showMutashabihat, setShowMutashabihat] = useState(false);

  // Handle shared links: ?surah=X&excerpt=Y
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const surahId = params.get('surah');
    const excerptId = params.get('excerpt');

    if (surahId) {
      api.get(`/surahs/${surahId}`).then(res => {
        setSelectedSurah(res.data);
        if (excerptId) {
          setSharedExcerptId(excerptId);
        }
        // Clean URL
        window.history.replaceState({}, '', window.location.pathname);
      }).catch(() => {});
    }
  }, []);

  if (showMutashabihat) {
    return <MutashabihatPage onBack={() => setShowMutashabihat(false)} />;
  }

  if (selectedSurah) {
    return (
      <SurahDetailPage
        surah={selectedSurah}
        onBack={() => { setSelectedSurah(null); setSharedExcerptId(null); }}
        sharedExcerptId={sharedExcerptId}
      />
    );
  }

  return (
    <SurahListPage
      onSelectSurah={setSelectedSurah}
      onOpenMutashabihat={() => setShowMutashabihat(true)}
    />
  );
}

function App() {
  return (
    <ThemeProvider defaultTheme="dark">
      <LanguageProvider>
        <AdminProvider>
          <PlayerProvider>
            <BrowserRouter>
              <AppContent />
              <Toaster 
                position="top-center"
                toastOptions={{
                  className: 'rounded-xl',
                }}
              />
            </BrowserRouter>
          </PlayerProvider>
        </AdminProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
